module.exports = {
          srcSet: __webpack_public_path__ + "2108dcaa4627e86a24e658465ff3ef25-486.png"+" 486w",
          images:[ {path: __webpack_public_path__ + "2108dcaa4627e86a24e658465ff3ef25-486.png",width: 486,height: 331}],
          src: __webpack_public_path__ + "2108dcaa4627e86a24e658465ff3ef25-486.png",
          toString:function(){return __webpack_public_path__ + "2108dcaa4627e86a24e658465ff3ef25-486.png"},
          
          width: 486,
          height: 331
        }